import React from 'react';
import { SectionHeading } from './SectionHeading';
import { SectionCTA } from './SectionCTA';
import { painPoints } from '../data/content';
export function PainPoints() {
  return <section className="w-full bg-brand-50 px-5 py-16 md:py-24" data-id="element-242" data-mp="26yph94puhgrt">
      <div className="mx-auto max-w-5xl" data-id="element-243" data-mp="26wbq36yacopj">
        <SectionHeading eyebrow="Does Any of This Sound Familiar?" title="If You've Experienced Even One of These Situations, This Resource Was Designed With You in Mind." data-id="element-244" data-mp="2bwzctgfhejdy" />

        <ol className="mt-12 grid gap-4 md:grid-cols-2" data-id="element-245" data-mp="21zuslm574xzs">
          {painPoints.map((p, i) => <li key={p.title} className="flex flex-col rounded-3xl bg-white p-6 shadow-sm ring-1 ring-brand-100" data-id="element-246" data-mp="1o03k20xg89t6" data-mpi={i}>
              <span className="text-4xl font-extrabold text-brand-200" data-id="element-247" data-mp="1szpslx2c11vn">{i + 1}</span>
              <h3 className="mt-2 text-xl font-extrabold leading-snug text-brand-950" data-id="element-248" data-mp="3idbgfx12otgx">{p.title}</h3>
              <p className="mt-3 text-base leading-relaxed text-brand-900/75" data-id="element-249" data-mp="3ncxu27ktcbq9">{p.body}</p>
              <p className="mt-auto pt-4 text-base font-bold text-brand-700" data-id="element-250" data-mp="1z058d3wz2sz3">{p.need}</p>
            </li>)}
        </ol>

        <div className="mx-auto mt-12 max-w-2xl text-center" data-id="element-251" data-mp="1u0smaldxdpxk">
          <p className="text-balance text-2xl font-extrabold leading-snug text-brand-950 sm:text-3xl" data-id="element-252" data-mp="27sqpkfkygrlt">
            You Don't Necessarily Need Another Collection of Sensory Activities.
          </p>
          <p className="mt-4 text-lg leading-relaxed text-brand-900/80" data-id="element-253" data-mp="1g1j4xidzgps0">
            You need a clearer process for deciding how those activities fit into a functional intervention plan. That's
            the central idea behind the Sensory Modulation Treatment Roadmap™.
          </p>
        </div>

        <SectionCTA label="Yes, I Want to Structure My Interventions" data-id="element-254" data-mp="1k3o1opzqa2iv" />
      </div>
    </section>;
}